module.exports = __webpack_public_path__ + "img/3.2a862d4b.jpg";